/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  KrigingParams,
  MinCurvatureParams,
  MovingAverageParams,
  RbfParams,
  SequentialConvergenceParams,
} from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class GridBuilderClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags GridBuilder
   * @summary Построение карты методом кригинга
   * @request POST:/geology/builder/kriging
   * @secure
   */
  gridBuilderRunKriging = (data: KrigingParams, params: RequestParams = {}) =>
    this.http.request<string, void>({
      path: `/geology/builder/kriging`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags GridBuilder
   * @summary Построение карты методом радиально-базисных функций
   * @request POST:/geology/builder/rbf
   * @secure
   */
  gridBuilderRunRbf = (data: RbfParams, params: RequestParams = {}) =>
    this.http.request<string, void>({
      path: `/geology/builder/rbf`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags GridBuilder
   * @summary Построение карты методом последовательных схождений
   * @request POST:/geology/builder/sc
   * @secure
   */
  gridBuilderRunSc = (data: SequentialConvergenceParams, params: RequestParams = {}) =>
    this.http.request<string, void>({
      path: `/geology/builder/sc`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags GridBuilder
   * @summary Построение карты методом скользящего среднего
   * @request POST:/geology/builder/mov_avg
   * @secure
   */
  gridBuilderRunMovingAverage = (data: MovingAverageParams, params: RequestParams = {}) =>
    this.http.request<string, void>({
      path: `/geology/builder/mov_avg`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags GridBuilder
   * @summary Построение карты методом минимальной кривизны
   * @request POST:/geology/builder/min_curvature
   * @secure
   */
  gridBuilderRunMinCurvature = (data: MinCurvatureParams, params: RequestParams = {}) =>
    this.http.request<string, void>({
      path: `/geology/builder/min_curvature`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
}
